// extracted by mini-css-extract-plugin
export var active = "_dc-7";
export var container = "_dc-0";
export var evenWidth = "_dc-4";
export var large = "_dc-5";
export var outlet = "_dc-8";
export var slide = "_dc-2";
export var small = "_dc-6";
export var tab = "_dc-3";
export var tabs = "_dc-1";